// IMPORTANT!!
//
// Webpack, including neutrino, configs may be assuming
// certain directory structures where svg or other icons
// are located.
//
// For example, svg icons under /icons dir are run through
// a separate react-svg-loader to turn them into react
// component automatically to use them inline.
//
// So be careful when changing dir structures, and if so
// make sure configs are modified accordingly.


// For svg, consider running them through svgomg first:
// https://jakearchibald.github.io/svgomg/


export { default as Add1F } from './streamline-filled-27-add-1.svg';
export { default as Remove1F } from './streamline-filled-27-remove-1.svg';
export { default as Picture3L } from './streamline-line-35-picture-3.svg';
export { default as CameraBoxF } from './streamline-filled-35-camera-box.svg';
export { default as CameraBoxL } from './streamline-line-35-camera-box.svg';
export { default as LayersShowL } from './streamline-line-18-layers-show.svg';
export { default as NewDocumentText } from './streamline-line-18-new-document-text.svg';
export { default as NewDocumentLayer } from './streamline-line-18-new-document-layer.svg';
export { default as EmailSend1 } from './streamline-line-6-email-send-1.svg';
export { default as AddCircle1 } from './streamline-line-27-add-circle-1.svg';
export { default as MusicNote1L } from './streamline-line-37-music-note-1.svg';
export { default as MusicNote3L } from './streamline-line-37-music-note-3.svg';

export { default as CodeSnippet } from './oneoff-code-snippet.svg';
export { default as NumberedList } from './oneoff-numbered-list.svg';
export { default as BulletedList } from './oneoff-bulleted-list.svg';



// WEBPACK FOOTER //
// ./src/shared/static/icons/index.js